module.exports = __webpack_public_path__ + "img/mask-face.a22b4c3b.svg";